import Vue from 'vue'
import VueRouter from 'vue-router'
import { restoreAuthSession, hasRestorableAuthSession } from '../api/authSession'
import tenantEndpoint from '../api/tenantEndpoint'
import Login from '../view/Login'
import LoginInDemo from '../view/LoginInDemo.vue'
import Register from '../view/Register'
import ResetPwd from '../view/ResetPwd.vue'
import Home from '../view/Home'
import TenantEntry from '../view/TenantEntry.vue'
import { loadChatRouteView, loadFriendRouteView, loadGroupRouteView } from './lazyViews'

Vue.use(VueRouter);

const router = new VueRouter({
	routes: [
		{
			path: '/',
			redirect: '/tenant'
		},
		{
			name: 'TenantEntry',
			path: '/tenant',
			component: TenantEntry,
			meta: {
				allowTenantEntry: true
			}
		},
		{
			name: 'Login',
			path: '/login',
			component: Login,
			meta: {
				authPage: true
			}
		},
		{
			name: 'DemoLogin',
			path: '/login/demo',
			component: LoginInDemo,
			meta: {
				authPage: true
			}
		},
		{
			name: 'Register',
			path: '/register',
			component: Register,
			meta: {
				authPage: true
			}
		},
		{
			name: 'ResetPwd',
			path: '/password/reset',
			component: ResetPwd,
			meta: {
				authPage: true
			}
		},
		{
			name: 'Home',
			path: '/home',
			component: Home,
			meta: {
				requiresAuth: true
			},
			children: [
				{
					name: 'Chat',
					path: '/home/chat',
					component: loadChatRouteView
				},
				{
					name: 'Friend',
					path: '/home/friend',
					component: loadFriendRouteView
				},
				{
					name: 'GROUP',
					path: '/home/group',
					component: loadGroupRouteView
				}
			]
		}
	]
});

router.beforeEach(async (to, from, next) => {
	const isTenantRoute = to.path === '/tenant';
	const restoreOnLaunch = isTenantRoute && !from.name && to.query.manual !== '1'
		&& hasRestorableAuthSession(tenantEndpoint.getRememberedTenantKey());
	if (isTenantRoute && !restoreOnLaunch) {
		next();
		return;
	}

	const requiresAuth = to.matched.some((record) => record.meta && record.meta.requiresAuth);
	const authPage = to.matched.some((record) => record.meta && record.meta.authPage);
	let tenantSession = null;
	try {
		tenantSession = await tenantEndpoint.bootstrapOnAppStart();
	} catch (error) {
		if (isTenantRoute) return next();
		next({
			path: '/tenant',
			query: {
				redirect: to.fullPath
			}
		});
		return;
	}

	if (!tenantSession) {
		if (isTenantRoute) return next();
		next({
			path: '/tenant',
			query: {
				redirect: to.fullPath
			}
		});
		return;
	}

	if (restoreAuthSession(tenantSession.tenantKey)) {
		try {
			const { refreshAccessToken } = await import('../api/httpRequest');
			await refreshAccessToken();
		} catch (error) {
			// Definitive expiry is cleared by HTTP auth handling. Network failures keep
			// the saved session so Home can reconnect after connectivity returns.
		}
	}
	const accessToken = sessionStorage.getItem('accessToken');
	if (restoreOnLaunch) return next(accessToken ? '/home/chat' : '/login');
	if (requiresAuth && !accessToken) {
		next('/login');
		return;
	}

	if (authPage && accessToken) {
		next('/home/chat');
		return;
	}

	next();
});

export default router;
